import { getLocalizedRoutes } from '@seek/melways-sites';
import type { RouteObject } from 'react-router-dom';

import App, { type AppProps } from './App';
import { routes } from './routes/routes';
import { FeatureToggleProviderV1 } from './v1/contexts/featureToggle';
import { MainLayout } from './v1/views/layouts/MainLayout';
import { DraftLoader } from './v2/components/DraftLoader';
import { HirerAccountAndUserDataLoader } from './v2/components/HirerAccountAndUserDataLoader';
import { FeatureToggleProviderV2 } from './v2/contexts/featureToggle';
import { HirerInfoProvider } from './v2/contexts/hirerInfo';

/**
 * Function to render all V1 specific providers, layouts and elements
 * @param appProps props coming from sku
 * @param element Element to render including the container
 * @returns
 */
const renderElementV1 = (appProps: AppProps, element: JSX.Element) => (
  <FeatureToggleProviderV1>
    <MainLayout site={appProps.site} language={appProps.language}>
      {element}
    </MainLayout>
  </FeatureToggleProviderV1>
);

/**
 * Function to render all V2 specific providers, layouts and elements
 * @param appProps props coming from sku
 * @param element Element to render including the container
 * @returns
 */
const renderElementV2 = (_appProps: AppProps, element: JSX.Element) => (
  <HirerAccountAndUserDataLoader>
    <DraftLoader>
      <FeatureToggleProviderV2>
        <HirerInfoProvider>{element}</HirerInfoProvider>
      </FeatureToggleProviderV2>
    </DraftLoader>
  </HirerAccountAndUserDataLoader>
);

export const createRoutes = (props: AppProps): RouteObject[] => {
  const localiedRoutes = getLocalizedRoutes(routes)(props.site).filter(Boolean);

  return [
    {
      element: <App {...props} />,
      children: localiedRoutes.map((route) => ({
        ...route,
        id: `${route.id}-${route.language}`,
        path: route.route,
        element:
          route.version === 1
            ? renderElementV1(props, route.element)
            : renderElementV2(props, route.element),
      })),
      id: 'root',
    },
  ];
};
